import { render, staticRenderFns } from "./ContactFieldsKundenbewertungRadios.vue?vue&type=template&id=146e61d0&"
import script from "./ContactFieldsKundenbewertungRadios.vue?vue&type=script&lang=js&"
export * from "./ContactFieldsKundenbewertungRadios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
